"use client";
import { useEffect } from "react";
import { supabase } from "@/db/supabaseclient";
import { useAuthStore } from "@/stores/useAuthStore";

export default function Auth({ children }: { children: React.ReactNode }) {
  const { fetchUser, setUser, setLoading } = useAuthStore();

  useEffect(() => {
    fetchUser();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        if (session?.user) {
          setUser({
            id: session.user.id,
            email: session.user.email!,
            deviceId: session.user.user_metadata?.deviceId ?? null,
          });
        }
        setLoading(false);
      }
    );

    return () => listener.subscription.unsubscribe();
  }, [fetchUser, setUser, setLoading]);

  return <>{children}</>;
}
